module.exports = __webpack_public_path__ + "img/mobile-neck-2_28x358.a57987ff.png";